export default "__VITE_ASSET__BV1s6_uL__"